
import { CasheirPaymentsMethod, cashierDeleveryType } from "@/types/CashierProductType";
import { AppConfig } from "@/utils/AppConfig";
import { FormikErrors } from "formik";
import { useTranslation } from "react-i18next";
import { BsCreditCard2Back } from "react-icons/bs";
import { MdOutlineWatchLater } from "react-icons/md";


type CashierPaymentCardProps = {
  name: string;

  selectedPaymentType: CasheirPaymentsMethod;
  isRequesting: boolean;
  paymentType: CasheirPaymentsMethod | null;
  setPaymentType: React.Dispatch<
    React.SetStateAction<CasheirPaymentsMethod | null>
  >;
  setFieldValue: (
    field: string,
    value: string | undefined,
    shouldValidate?: boolean,
  ) =>
    | Promise<void>
    | Promise<
      FormikErrors<{
        cashPaid: undefined;
        networkPaid: undefined;
      }>
    >;
  resetForm: () => void;
  deleveryType?: cashierDeleveryType
};

function CashierPaymentCard({
  name,
  selectedPaymentType,
  isRequesting,
  paymentType,
  setPaymentType,
  setFieldValue,
  resetForm,
  deleveryType
}: CashierPaymentCardProps) {
  const { t } = useTranslation();

  const iconsBasedOnType = {
    cash: AppConfig.currency.icon("currentcolor", 25),
    card: <BsCreditCard2Back size={25} />,
    "cash-card": (
      <div className="flex items-center justify-center gap-3">
        <div className="flex flex-col items-center justify-center gap-1 text-lg">
          <BsCreditCard2Back size={25} />
          {t("paymentMethods.card")}
        </div>

        <span className="block h-full w-[1px] bg-sidebar"></span>

        <div className="flex flex-col items-center justify-center gap-1">
          {AppConfig.currency.icon("currentcolor", 25)}
          {t("cashierPaymentCard.cash")}
        </div>
      </div>
    ),
    "pay-later" : <MdOutlineWatchLater size={30} />
  };

  const handleChoosePaymentType = () => {
    setFieldValue("cashPaid", undefined);
    setFieldValue("networkPaid", undefined);
    resetForm();
    setPaymentType(selectedPaymentType);
    setFieldValue("type", deleveryType);
  };

  if(selectedPaymentType === "pay-later" && deleveryType !== "internal") return null

  return (
    <button
      disabled={isRequesting}
      onClick={handleChoosePaymentType}
      className={`flex h-[100px] w-[180px] flex-grow flex-col items-center justify-center gap-2 rounded-sm bg-[#e0eaee] text-xl font-bold text-sidebar duration-150 hover:border hover:border-sidebar disabled:bg-gray-400 disabled:text-gray-600 disabled:hover:border-gray-400 ${paymentType === selectedPaymentType ? "border border-sidebar" : ""} `}
    >
      {iconsBasedOnType[selectedPaymentType]}
      {selectedPaymentType === "cash-card" ? null : <p>{t(name)}</p>}
    </button>
  );
}

export default CashierPaymentCard;
